"use strict";
anonymousMode.classy.controller({
    name: "AnonymousModeController",
    inject: ["$scope", "$rootScope", "StandardCudFactory", "SchoolModelService", "BinFactory", "$http"],
    init: function()
    {
        this.id = this.SchoolModelService.get()[0].recordID;
        this.$.item = this.SchoolModelService.get()[0];
        this.$.SchoolModelService = this.SchoolModelService;
        this.$rootScope.model = this.SchoolModelService;
        this.$.items = this.BinFactory.getApplications();
        this.$.origItems = angular.copy(this.BinFactory.getApplications());
        this.$.input = {};
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.showvalue=0;
    },
   submit: function(scope, instance, form)
    {
        var altIDs = [];
        for(var i = 0; i < this.$.items.length; i++)
        {
            if (this.$.origItems[i].Alt_ID != this.$.items[i].Alt_ID)
                altIDs.push({ applicationID: this.$.items[i].applicationID, Alt_ID: this.$.items[i].Alt_ID })
        }
        var parent = this;
        if (form.$valid)
        {
            instance.options.factor  = 0.3;
            this.SchoolModelService.put(this.id, this.$.item, instance).then(function (response) {
                parent.$http.post("api/app/AltId", altIDs);
            });
        }
        else
        {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) 
    {
        this.SchoolModelService.set(this.SchoolModelService.data);
        if (typeof callback !== 'undefined')
            callback();
    },
    printList: function() {
        this.$.showvalue=1;
        var mywindow = window.open('', 'my div', 'height=400,width=800');
        mywindow.document.write('<html><head><title>my div</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write($('#altIDList').html());
        mywindow.document.write('</body></html>');
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10
        mywindow.print();
        mywindow.close();
        this.$.showvalue=0;
        return true;
    }

});

